<template>
  <div class="max-w-screen-sm mx-auto w-full px-8 mt-8" id="voucher">
    <!-- printer  -->
    <div ref="voucher" class="bg-gray-500 py-3 px-3" id="voucher-printer">
      <div class="h-4 bg-black w-full"></div>
    </div>
    <div class="px-6 overflow-hidden relative pb-2" :class="showVoucher ? '-mt-6 pt-6 pb-8' : 'h-16'">

      <div class="flex flex-col justify-center overflow-hidden absolute z-0 inset-x-4"
        :class="{ 'opacity-0': showVoucher, '': !showVoucher }">
      
        <button class="max-w-96 w-full mx-auto relative p-2 mt-4 animate-bounce" @click="generateVoucher">
          <img src="/img/button-shop.png" class="absolute inset-0 w-full h-full z-0">
          <div class="border-2 border-white rounded-md text-center relative z-10">
            <p class="text-lg flex justify-center items-center gap-1 text-white font-semibold">Generar Voucher</p>
          </div>
        </button>
      </div>



      <!-- voucher -->
     <div class="bg-gradient-to-t from-white to-[#E2E8F0] -mt-6 drop-shadow-md px-2 flex flex-col justify-center 
              overflow-hidden transition-all duration-500 ease-out transform voucher-shadow"
        :class="{ 'py-4': showVoucher, '-translate-y-[150%]': !showVoucher, 'h-0': !showVoucher }">
        <img src="/img/logo-recibo.png" alt="" class="w-16 mx-auto">
        <div class="hidden">{{ counter }}</div>
        <!-- item -->
        <div v-for="category in categories" :key="category.id">
          <div v-for="product in category.products" :key="product.id">
          </div>
          <!-- end item -->
        </div>
        <div class="w-full mt-8 flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="233" height="2" viewBox="0 0 233 2" fill="none">
            <path opacity="0.5" d="M1 1H232" stroke="#64748B" stroke-linecap="round" />
          </svg>
        </div>
        <div class="flex justify-between mt-4 text-black px-3" v-if="shopLength > 0">
          <div class="text-sm font-semibold">Subtotal:</div>
          <p class="text-sm font-semibold">
            s/. <span class="font-semibold text-xl">{{ (calculateSubtotal() / 100).toFixed(2) }}</span>
          </p>
        </div>
        <button class="max-w-96 w-full mx-auto relative p-2 mt-4" @click="$emit('open-form')" v-if="shopLength > 0">
          <div class="border-2 border-white rounded-md text-center relative z-10">
            <p class="text-lg flex justify-center items-center gap-1 text-white font-semibold">Finalizar Compra</p>
          </div>
        </button>

        <div class="max-w-96 w-full mx-auto relative p-2 mt-4" v-if="shopLength == 0">
          <div class="bg-black border-2 border-white rounded-md text-center relative z-10">
            <p class="flex justify-center items-center gap-1 text-white font-semibold py-1">Add products to your quote</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: Array
  },
  data() {
    return {
      counter: 0,
      showVoucher: false,
      shopLength: 0
    };
  },
  mounted() {
    setInterval(() => {
      this.counter++;
      this.checkCart();
      
    }, 100);

    this.observeVoucher();
  },
  methods: {
    calculateSubtotal() {
      let subtotal = 0;
      for (let category of this.categories) {
        for (let product of category.products) {
        }
      }
      return subtotal;
    },
    checkCart() {
      this.shopLength = 0;
      const shoppingCart = document.getElementById('shopping-cart');
      const shoppingCartMobile = document.getElementById('shopping-cart-mobile');
      for (let category of this.categories) {
        for (let product of category.products) {
         
        }
      }
      if (this.shopLength > 0) {
        shoppingCart.classList.remove('hidden');
        shoppingCart.innerText = this.shopLength;
        shoppingCartMobile.classList.remove('hidden');
        shoppingCartMobile.innerText = this.shopLength;
      } else {
        shoppingCart.classList.add('hidden');
        shoppingCartMobile.classList.add('hidden');
      }
    },
    observeVoucher() {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setTimeout(() => {
              this.showVoucher = true;
            }, 400);
            console.log('Voucher is not visible');
            observer.disconnect(); 
          }
        },
        { threshold: 0.8 }
      );
      observer.observe(this.$refs.voucher);
    }
    
  },
};
</script>

<style>
.voucher-shadow {
  box-shadow: 0px 34px 30px -30px black inset, -1px 8px 12px 0px #00000057;
}

.img-pixelated {
  image-rendering: pixelated;
}
</style>
